import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import { GoogleOAuthProvider } from '@react-oauth/google';

import { configureStore } from "./store";

ReactDOM.render(
  <Provider store={configureStore({})}>
        <GoogleOAuthProvider clientId="378585678840-ir3omeld421vvftffln8rjb5fn8ud3s0.apps.googleusercontent.com">
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
    </GoogleOAuthProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();